import React from 'react';

import invariant from 'tiny-invariant';

import type { GlobalSideNavigationProps } from '../../common/types';
import { useNetworkSideNavUserData } from '../../controllers/user-state/persistence/use-network-side-nav-user-data';

import { GlobalSideNavContent } from './GlobalSideNavContent';
import { GlobalSideNavWrapper } from './GlobalSideNavWrapper';

export function GlobalSideNavigationWithNetworkStore(props: GlobalSideNavigationProps) {
	const { networkStorageParams, ...innerProps } = props;

	invariant(
		networkStorageParams?.entityAri &&
			networkStorageParams?.ownerAri &&
			networkStorageParams?.queryRef,
		'Please provide networkStorageParams when using customization',
	);

	// This is user data for the menu and the sidebar
	const userStoreProps = useNetworkSideNavUserData(networkStorageParams);

	return (
		<GlobalSideNavWrapper {...userStoreProps}>
			<GlobalSideNavContent {...innerProps} />
		</GlobalSideNavWrapper>
	);
}
